import {
    fetchUserInfo,
    forgotPassword,
    resetPassword,
    loginCandidate,
    logOutUserService,
} from '../../../services/auth.service';
import * as actionTypes from './actionTypes';
import { _setToken, setupRefreshTimer } from '../../../utils/authFunctions';

export const setAuthData = (data) => {
    return {
        type: actionTypes.SET_AUTH_DATA,
        data,
    };
};

export const signInUser = (userData) => {
    return dispatch => {
        return loginCandidate(userData).then(res => {
            _setToken(res?.data?.tokens);
            setupRefreshTimer();
            dispatch(setAuthData(res?.data));
            return res;
        }).catch(err => {
            console.log(err);
            return err;
        });
    };
};

export const getUserInfo = () => {
    return dispatch => {
        return fetchUserInfo().then(res => {
            dispatch({ type: actionTypes.SET_USER_INFO, data: res?.data });
            return res;
        }).catch(err => {
            console.log(err);
            return err;
        });
    };
};

export const logOutUser = () => {
    return dispatch => {
        return logOutUserService().then(res => {
            localStorage.clear();
            dispatch({ type: 'CLEAR_STORE' });
            return res;
        }).catch(err => {
            console.log(err);
            return err;
        });
    };
};

export const forgotCandidatePassword = (data) => {
    return dispatch => {
        return forgotPassword(data).then(res => {
            return res;
        }).catch(err => {
            console.log(err);
            return err;
        });
    };
}

export const resetCandidatePassword = (query="", data) => {
    return dispatch => {
        return resetPassword(query, data).then(res => {
            return res;
        }).catch(err => {
            console.log(err);
            return err;
        });
    };
}
